export default __webpack_public_path__ + "static/media/product-08.58a323c6.jpg";